import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Box, CircularProgress, Grid } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { Toggle } from "../../../../../components/toggle";
import { ShaDowBox } from "../../../../../components/boxes";
import { getData, currencyFormatter } from "../../../../../services";
import { tenancyChartBars, unitGraphFooter } from "../../../constants";
import { NoDataCard, TenancyChart } from "../../../../../components/parts";

const GRAPH_UNITS = ["Now", "5y"];

const squareChartBars = tenancyChartBars.map((bar) => ({ ...bar, barSize: 18, unit: "" }));
const percentChartBars = squareChartBars.map((bar) => ({ ...bar, unit: "%" }));

export const TenancyDataGraph = ({ unit }) => {
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;
  const [byFilter, setByFilter] = useState(GRAPH_UNITS[0]);
  const [chartData, setChartData] = useState([]);
  const [existsDataBeforeCurrentMonth, setExistsDataBeforeCurrentMonth] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getData(
      `/praas/v2/buildings/${unit.building.id}/properties/units/${
        unit.id
      }/charts/?date-filter=${byFilter.toLowerCase()}`,
      (data) => {
        setExistsDataBeforeCurrentMonth(data.exists_data_before_current_month);
        setChartData([
          {
            title: `${currencyFormatter(data.lease_payment_per_square_today, currencySymbol)}/${
              user?.unit_system
            }`,
            checkValue: data.lease_payment_per_square_today,
            titleColor: COLORS.purple,
            suffix: "(Today)",
            suffixColor: COLORS.purple,
            chartData: [data.lease_payment],
            name: "Lease Payment",
            onlyZeroValues: data.lease_payment._unit === 0,
            key: "lease_payment",
            bars: squareChartBars,
          },
          {
            title: `${data.economic_vacancy_days} days`,
            checkValue: data.economic_vacancy_days,
            titleColor: COLORS.purple,
            suffix: "(Last year)",
            suffixColor: COLORS.purple,
            chartData: [data.economic_vacancy],
            name: "Total economic vacancy",
            onlyZeroValues: data.economic_vacancy._unit === 0,
            key: "economic_vacancy",
            bars: percentChartBars,
          },
          {
            title: `${data.physical_vacancy_days} days`,
            checkValue: data.physical_vacancy_days,
            titleColor: COLORS.purple,
            suffix: "(Last year)",
            suffixColor: COLORS.purple,
            chartData: [data.physical_vacancy],
            name: "Total physical vacancy",
            onlyZeroValues: data.physical_vacancy._unit === 0,
            key: "physical_vacancy",
            bars: percentChartBars,
          },
        ]);
      }
    ).finally(() => setLoading(false));

    return () => setChartData([]);
  }, [byFilter]);

  if (!chartData.length && !loading)
    return (
      <NoDataCard
        footerNames={["In this unit", "In this building", "Avg. portfolio", "Avg. Industry"]}
      />
    );

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        {existsDataBeforeCurrentMonth ? (
          <Grid container>
            <Grid item style={{ marginLeft: "auto" }}>
              <Toggle
                value={byFilter}
                options={GRAPH_UNITS}
                onChanged={setByFilter}
                styles={{ width: 30, fontSize: 12 }}
              />
            </Grid>
          </Grid>
        ) : null}
        {loading ? (
          <Grid container justifyContent="center" alignItems="center" style={{ minHeight: 200 }}>
            <CircularProgress />
          </Grid>
        ) : (
          <Box style={{ marginTop: 10 }}>
            <TenancyChart
              chartData={chartData}
              checkTitleKeys={["lease_payment", "economic_vacancy", "physical_vacancy"]}
              showTitleOnCheck={true}
              graphFooterItems={unitGraphFooter}
            />
          </Box>
        )}
      </Box>
    </ShaDowBox>
  );
};
